import React, { useEffect, useRef, useState } from 'react'
import translations from '../../shared/Translations';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './index.css'
import { FaLessThanEqual } from 'react-icons/fa';
import AOS from "aos";
import "aos/dist/aos.css";
import superAdminApis from '../../api/services/admin-pages/superAdmin';
import { toast } from 'react-toastify';
import CommonPagination from '../../components/pagination';
import gpay from '../../assets/images/gpay-how-to-create-or-find-upi-1200x675.jpg'
import phonepe from '../../assets/images/phonepes.png'
import { baseURL } from '../../api/api';
import Noimage from "../../assets/images/noimages.jpg";
import { Line, Doughnut } from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler
} from "chart.js";



ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Filler
);


function AddFinance() {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      mirror: true,
    });
  }, []);



  const navigate = useNavigate();
  const [isEditing, setIsEditing] = useState(false)
  const [submit, setSubmit] = useState(false)
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [loading, setLoading] = useState(false)
  const [financeDeleteId, setFinanceDeleteId] = useState("")
  const [customerName, setCustomerName] = useState("")
  const [currentPage, setCurrentPage] = useState(1);
  // const [recordsPerPage] = useState(10);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSizes, setPageSizes] = useState([]);

  const [aadharImages, setAadharImages] = useState("");


  const [lang, setLang] = useState("en");
  const t = (key) => translations[lang][key] || key;

  useEffect(() => {
    const savedLang = localStorage.getItem("lang");
    if (savedLang) setLang(savedLang);
  }, []);


  // ========================================================================================

  const location = useLocation();
  const { customer } = location?.state || {};

  const [imageSrc, setImageSrc] = useState(
    customer?.liveImage
      ? `${baseURL}${customer.liveImage.path}${customer.liveImage.altered_file_name}`
      : null
  );

  const [capturedPhoto, setCapturedPhoto] = useState(null);


  const fileInputRef = useRef(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);



  // 📸 Upload Button → opens file picker

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };
  const [showCamera, setShowCamera] = useState(false);

  // Live Upload

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const previewUrl = URL.createObjectURL(file);

    // set preview first
    setForm(prev => ({
      ...prev,
      imgFile: file,
      imgPreview: previewUrl,
    }));
    setImageSrc(previewUrl);

    // upload file
    const uploadedId = await handleCustomerPhotoUpload(file);

    // update LIVE UPLOADED ID (not uploadedImgId)
    setForm(prev => ({
      ...prev,
      liveUploadedId: uploadedId,
    }));
  };


  const handleCustomerPhotoUpload = async (file) => {
    const formData = new FormData();
    formData.append("files[0]", file);

    try {
      const res = await superAdminApis.customerImageUpload(formData);

      if (res?.apiStatus?.code === "200") {
        toast.success(res.apiStatus.message || "File uploaded successfully!");
        return res?.responseData?.[0]?.img_id?.toString() || null;

      } else {
        toast.error(res?.apiStatus?.message || "Upload failed.");
        return null;
      }
    } catch (err) {
      console.error("Image upload error:", err);
      toast.error("Image upload failed. Please try again.");
      return null;
    }
  };




  // 🔁 Toggle camera front/back
  const [cameraFacing, setCameraFacing] = useState('user');
  const handleToggleCamera = () => {
    setCameraFacing((prev) => (prev === 'user' ? 'environment' : 'user'));
  };

  // 🧩 Convert dataURL to file
  const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) u8arr[n] = bstr.charCodeAt(n);
    return new File([u8arr], filename, { type: mime });
  };

  // 📸 Capture from camera


  const handleCapture = async () => {
    if (!videoRef.current) return;

    const canvas = document.createElement("canvas");
    canvas.width = videoRef.current.videoWidth;
    canvas.height = videoRef.current.videoHeight;
    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
    const imageDataUrl = canvas.toDataURL("image/png");
    const capturedFile = dataURLtoFile(imageDataUrl, "captured-photo.png");

    const uploadedId = await handleCustomerPhotoUpload(capturedFile);

    console.log(uploadedId);


    setForm(prev => ({
      ...prev,
      imgFile: capturedFile,
      imgPreview: imageDataUrl,
      uploadedImgId: uploadedId,
      liveUploadedId: uploadedId,
    }));
    setImageSrc(imageDataUrl);
    setCapturedPhoto(imageDataUrl);

    const closeBtn = document.getElementById("closeCameraModalBtn");
    if (closeBtn) closeBtn.click();
  };


  useEffect(() => {
    if (!showCamera) return;

    let stream;

    const startCamera = async () => {
      try {
        stream = await navigator.mediaDevices.getUserMedia({
          video: {
            facingMode: cameraFacing,
          },
        });

        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          await videoRef.current.play();
        }
      } catch (err) {
        console.error(err);
      }
    };

    startCamera();

    return () => {
      if (stream) {
        stream.getTracks().forEach(track => track.stop());
      }
    };
  }, [showCamera, cameraFacing]);
  // 🎥 Start camera when modal opens
  useEffect(() => {
    const modal = document.getElementById('cameraModal');
    if (!modal) return;

    const handleShow = async () => {
      if (!navigator?.mediaDevices?.getUserMedia) {
        showCameraError(modal, 'Camera not available.');
        return;
      }

      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: cameraFacing },
        });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          await videoRef.current.play();
        }
      } catch (err) {
        console.error('Camera access error:', err);
        showCameraError(modal, 'Cannot access camera right now.');
      }
    };

    modal.addEventListener('shown.bs.modal', handleShow);
    return () => modal.removeEventListener('shown.bs.modal', handleShow);
  }, [cameraFacing]);

  // ❌ Stop camera when modal closes
  useEffect(() => {
    const modal = document.getElementById('cameraModal');
    if (!modal) return;

    const handleHide = () => {
      if (videoRef.current && videoRef.current.srcObject) {
        const tracks = videoRef.current.srcObject.getTracks();
        tracks.forEach((track) => track.stop());
        videoRef.current.srcObject = null;
      }
    };

    modal.addEventListener('hidden.bs.modal', handleHide);
    return () => modal.removeEventListener('hidden.bs.modal', handleHide);
  }, []);

  // ⚠️ Helper for camera error
  const showCameraError = (modal, message) => {
    const body = modal.querySelector('.modal-body');
    if (body) {
      body.innerHTML = `
        <p class="text-danger">${message}</p>
        <button class="btn btn-secondary mt-3" data-bs-dismiss="modal">Close</button>
      `;
    }
  };


  // Adhar Upload
  const aadharInputRef = useRef(null);
  const handleAadharChange = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    const previews = files.map(f => URL.createObjectURL(f));

    setForm(prev => ({
      ...prev,
      adharFile: files,
      adharPreview: previews
    }));

    // Upload multiple files in ONE API call
    const uploadedIds = await handleAadharMultiUpload(files);

    setForm(prev => ({
      ...prev,
      adharUploadedId: uploadedIds
    }));
  };



  const handleAadharMultiUpload = async (files) => {
    const formData = new FormData();

    files.forEach((file, index) => {
      formData.append(`files[${index}]`, file);  // KEY PART!
    });

    try {
      const res = await superAdminApis.customerImageUpload(formData);

      if (res?.apiStatus?.code === "200") {
        toast.success("Aadhar uploaded successfully!");

        return res.responseData.map(x => x.img_id.toString());
      } else {
        toast.error(res.apiStatus.message || "Upload failed");
        return [];
      }

    } catch (err) {
      console.error(err);
      toast.error("Upload failed");
      return [];
    }
  };



  // =========================================================================================

  const handleBackCustomer = () => {
    navigate("/dashboard");
  };

  const [form, setForm] = useState({
    name: "",
    date: "",
    amount: "",
    phoneNumber: "",
    interestRate: "",
    payDuration: "",
    // Separate Aadhar state
    adharFile: [],
    adharPreview: [],
    adharUploadedId: [],
    // Live image preview
    liveFile: null,
    livePreview: customer?.liveImage
      ? `${baseURL}${customer?.liveImage?.path}${customer?.liveImage.altered_file_name}`
      : "",
    liveUploadedId: null,

    // calculated fields
    intrestamount: "",
    weeklyInterest: "",
    totalPayable: "",
    remain_interest_amount: "",
    remain_loan_amount: ""
  });

  const [payModal, setPayModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [payForm, setPayForm] = useState({
    principalPay: "",
    interestPay: "",
    payDate: "",
    payMethod: "",
    gpayNumber: "",
    phonePeNumber: "",
    accountNumber: ""
  });


  const handlePayClick = async (item) => {
    try {
      setLoading(true);

      const response = await superAdminApis.financeGet(item.id);

      if (response?.apiStatus?.code === "200") {
        const data = response.result;

        setSelectedItem(data);

        setPayForm({
          principalPay: data.remaining || "",
          interestPay: data.interest || "",
          payDate: "",
          payMethod: "",
          gpayNumber: "",
          phonePeNumber: "",
          accountNumber: "",
          name: data.name
        });

        setPayModal(true);
      }

    } catch (err) {
      console.error("Pay API error:", err);
    } finally {
      setLoading(false);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phoneNumber") {
      if (!/^\d*$/.test(value)) return;
      if (value.length > 10) return;
    }

    setForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };


  const closeClick = () => {
        setSubmit(false)
    setForm({
      name: "",
      date: "",
      amount: "",
      rate: "",
      intrestamount: "",
      interestRate: "",
      payMethod: "",
      payDuration: "",
      gpayNumber: "",
      phonePeNumber: "",
      phoneNumber: "",
      weeklyInterest: "",
      totalPayable: "",
      remain_interest_amount: "",
      remain_loan_amount: "",
      adharFile: [],
      adharPreview: [],
      adharUploadedId: [],
      liveFile: null,
      livePreview: "",
      liveUploadedId: null,
    });
    // Clear file input
    if (aadharInputRef.current) {
      aadharInputRef.current.value = "";
    }
    setAadharImages("")
    setImageSrc(null);
    setIsEditing(false);
    setSelectedItem(null);
  };

  const closeClickPay = () => {
    setSubmit(false)
    setPayForm({
      interestRate: "",
      principalPay: "",
      interestPay: "",
      payDate: "",
      payMethod: "",
      gpayNumber: "",
      phonePeNumber: "",
      accountNumber: "",
      remain_interest_amount: "",
      remain_loan_amount: "",
      adharFile: [],
      adharPreview: [],
      adharUploadedId: [],
      liveFile: null,
      livePreview: "",
      liveUploadedId: null,
    })
    setAadharImages("")
    setIsEditing(false);
    setSelectedItem(null)
    setImageSrc(null)
  }

  useEffect(() => {
    const amount = Number(form.amount || 0);
    const rate = Number(form.interestRate || 0);
    const duration = form.payDuration;

    if (!amount || !rate || !duration) return;

    const totalInterest = (amount * rate) / 100;

    let weeklyInterest = 0;
    let totalPayable = 0;

    if (duration === "Daily") {
      console.log('mmmmmmmmm');

      weeklyInterest = totalInterest / 100;
      totalPayable = amount + totalInterest;
    }

    if (duration === "Weekly") {
      console.log('mmmmmmmmm');

      weeklyInterest = totalInterest / 10;
      totalPayable = amount + totalInterest;
    }

    if (duration === "Monthly") {
      weeklyInterest = totalInterest / 4;
      totalPayable = amount + totalInterest;
    }

    setForm((prev) => ({
      ...prev,
      intrestamount: totalInterest.toFixed(2),
      weeklyInterest: weeklyInterest.toFixed(2),
      totalPayable: totalPayable.toFixed(2),
    }));
  }, [form.amount, form.interestRate, form.payDuration]);

  const calculateFinance = (amount, rate, weeks) => {
    const numericRate = parseFloat(rate);

    const totalInterest = (amount * numericRate) / 100;
    const weeklyInterest = totalInterest / weeks;
    const totalPayable = amount + totalInterest;

    return {
      totalInterest,
      weeklyInterest,
      totalPayable
    };
  };

  const weeks = 10;

  const [financeList, setFinanceList] = useState([]);


  useEffect(() => {
    handleFinanceList(currentPage);
    setSubmit(false)
  }, [currentPage, recordsPerPage]);


  const handleFinanceList = (page) => {
    setLoading(true);

    const apiData = {
      pageIndex: page - 1,
      dataLength: recordsPerPage,
    };

    superAdminApis.financeList(apiData)
      .then((responseData) => {
        if (responseData?.apiStatus?.code === "200") {
          setLoading(false);
          setFinanceList(responseData?.result?.financeDetails || []);
          setTotalRecords(responseData?.result?.totalRecordCount || 0);
          const sizes = responseData?.result?.totalSort;

          console.log(sizes);


          setPageSizes(
            Array.isArray(sizes)
              ? sizes
              : []
          );
        } else {
          setFinanceList([]);
          setLoading(false);
          // toast.error(responseData?.apiStatus?.message || "Failed to fetch data");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching customer details:", error);
        toast.error("An error occurred while fetching data.");
      });
  };
  const handleGetFinanceAmt = (loanId) => {

    // superAdminApis.financeGetAmt(loanId)
    superAdminApis.financeGetcountAmt()
      .then((responseData) => {
        if (responseData?.apiStatus?.code === "200") {
          setTotalFinanceLoans(responseData?.result?.finance_amount || []);
          settotalLoan(responseData?.result?.total_loan_amount)
          settotalInterest(responseData?.result?.total_interest_amount)
          setremainingFinanceAmt(responseData?.result?.remaining_finance_amount)
          setremainingLoanAmt(responseData?.result?.remaining_loan_amount)

        } else {
          setTotalFinanceLoans([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching customer details:", error);
        toast.error("An error occurred while fetching data.");
      });
  };


  const handleGetFinanceUpdate = () => {
    const apiData = {
      id: 1,
      finance_amount: totalFinanceLoans
    }
    superAdminApis.financeUpdateAmt(apiData)
      .then((responseData) => {
        if (responseData?.apiStatus?.code === "200") {
          handleGetFinanceAmt(1)
        }
      })
      .catch((error) => {
        console.error("Error fetching customer details:", error);
        toast.error("An error occurred while fetching data.");
      });
  };


  const handleDeleteFinance = () => {
    superAdminApis.financeDeleteAPI(financeDeleteId)
      .then((responseData) => {
        if (responseData.apiStatus.code === '200') {
          const newTotalRecords = totalRecords - 1;
          setTotalRecords(newTotalRecords);
          let totalPages = Math.ceil(newTotalRecords / recordsPerPage);
          if (currentPage > totalPages) {
            setCurrentPage(totalPages || 1);
          }
          else if (currentPage < 1) {
            setCurrentPage(1);
          }
          const closeButton = document.getElementById("closedeleteModal");
          if (closeButton) {
            handleFinanceList(currentPage);
            closeButton.click();
          }
          toast.success(responseData?.apiStatus?.message);
        } else {
          toast.error(responseData?.apiStatus?.message);
        }
      })
      .catch((error) => {
        setLoading(false)
        console.error("Error during login:", error);
        toast.error("An error occurred during login.");
      });
  };


  useEffect(() => {
  const modal = document.getElementById("addfinance");

  const handleHidden = () => {
    setSubmit(false);
  };

  modal.addEventListener("hidden.bs.modal", handleHidden);

  return () => {
    modal.removeEventListener("hidden.bs.modal", handleHidden);
  };
}, []);

  const totalPages = Math.ceil(totalRecords / recordsPerPage);



  const financeCreate = async () => {
    // if (submit) return; 

    setSubmit(true);

     if (!form.phoneNumber || !form.date) {

      return;
    }

    const payload = {
      name: form.name,
      date: form.date,
      phone_no: form.phoneNumber,



      loan_amount: Number(form.amount),
      interest_rate: Number(form.interestRate),
      pay_duration: form.payDuration,
      aadhar_img: form.adharUploadedId,
      live_img: form.liveUploadedId,
      total_interest: Number(form.intrestamount),
      weekly_interest: Number(form.weeklyInterest),
      total_payable: Number(form.totalPayable),
      remain_interest_amount: Number(form.remain_interest_amount),
      remain_loan_amount: Number(form.remain_loan_amount),
    };

    try {
      setSubmit(true);

      let responseData;

      if (isEditing) {
        payload.id = form.id;
        responseData = await superAdminApis.financeUpdateAPI(payload);
      } else {
        responseData = await superAdminApis.financeCreate(payload);
      }

      if (responseData?.apiStatus?.code === "200") {
        console.log("✅ Success");
        toast.success(responseData?.apiStatus?.message)
        const modal = document.getElementById("addfinance"); // or your modal id
        const modalInstance = window.bootstrap.Modal.getInstance(modal);
        modalInstance.hide();

        // 🔄 reset form
        setForm({
          id: "",
          name: "",
          date: "",
          phoneNumber: "",
          amount: "",
          interestRate: "",
          payDuration: "",
          intrestamount: "",
          weeklyInterest: "",
          totalPayable: "",
          adharFile: [],
          adharPreview: [],
          adharUploadedId: [],
          liveFile: null,
          livePreview: "",
          liveUploadedId: null,
        });
        setAadharImages("")
        setIsEditing(false);
        setImageSrc(null)
        handleFinanceList()


      } else {
        console.error("❌ API Error:", responseData);
        toast.error(responseData?.apiStatus?.message)
      }

    } catch (error) {
      console.error("❌ Server Error:", error);
    } finally {
      setSubmit(false);
    }
  };

  const handleEdit = (item) => {
    setIsEditing(true);
    setAadharImages(item?.aadharImage || []);

    setForm({
      id: item.id,

      name: item.name || "",
      date: item.date || "",
      phoneNumber: item.phone_no || "",
      adharPreview: item?.aadharImage || [],
      amount: Number(item.loan_amount || 0),
      interestRate: Number(item.interest_rate || 0),
      payDuration: item.pay_duration || "",
      adharUploadedId: item.aadhar_img
        ? JSON.parse(item.aadhar_img)
        : [],
      livePreview: item?.live_img_name
        ? `${baseURL}${item?.live_img_path}${item?.live_img_name}`
        : "",
      liveUploadedId: item.live_img || null,
      intrestamount: Number(item.total_interest || 0),
      weeklyInterest: Number(item.weekly_interest || 0),
      totalPayable: Number(item.total_payable || 0),
      remain_interest_amount: item?.remain_interest_amount,
      remain_loan_amount: item?.remain_loan_amount
    });
    console.log(item, "Item")
  };


  // const getCurrentDateTime = () => {
  //   const now = new Date();

  //   // YYYY-MM-DD
  //   const date = now.toISOString().split("T")[0];

  //   // 12-hour time with AM/PM
  //   let hours = now.getHours();
  //   const minutes = now.getMinutes().toString().padStart(2, "0");

  //   const ampm = hours >= 12 ? "PM" : "AM";

  //   hours = hours % 12;
  //   hours = hours ? hours : 12; // 0 -> 12

  //   const time = `${hours}:${minutes} ${ampm}`;

  //   return `${date} ${time}`;
  // };


  const getCurrentDateTime = () => {
    const now = new Date();

    const date = now.toLocaleDateString("en-CA");
    const time = now.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    });

    return `${date} ${time}`;
  };

  const handlePay = async () => {
    setSubmit(true);

    if (!payForm.payDate) {

      return;
    }

    // Remaining Principal
const remainingPrincipal =
  selectedItem?.remain_interest_amount == null
    ? Number(selectedItem?.loan_amount || 0)
    : Number(selectedItem?.remain_loan_amount || 0);

// User entered Principal
const enteredPrincipal = Number(payForm.principalPay || 0);

// User entered Interest
const enteredInterest = Number(payForm.interestPay || 0);

// Full principal pay செய்யும்போது interest கட்டணும்
if (
  enteredPrincipal >= remainingPrincipal &&
  selectedItem?.interest_status !== "false" &&
  enteredInterest <= 0
) {
  toast.error("Please pay the interest before closing the loan.");
  return;
}


    //   if (Number(payForm.principalPay) > Number( !selectedItem?.remain_interest_amount ||
    //     selectedItem?.remain_interest_amount === "0"
    //       ? selectedItem?.total_interest || "0"
    //       : selectedItem?.remain_interest_amount)) {
    //   toast.error("Principal amount exceeds remaining loan!");
    //   return;
    // }

    const payload = {
      id: selectedItem.id,

      name: selectedItem.name,
      date: selectedItem.date,
      phone_no: selectedItem.phone_no,

      loan_amount: selectedItem.loan_amount,
      interest_rate: selectedItem.interest_rate,
      pay_duration: selectedItem.pay_duration,
      live_img:
        selectedItem.live_img_id,
      aadhar_img:
        selectedItem.aadhar_img_id
          ? JSON.parse(selectedItem.aadhar_img_id)
          : [],
      total_interest: selectedItem.total_interest,
      weekly_interest: selectedItem.weekly_interest,
      total_payable: selectedItem.total_payable,

      interest_pay: payForm.interestPay,
      principal_pay: payForm.principalPay,
      pay_date: `${payForm.payDate} ${getCurrentDateTime().split(" ")[1]}`,
      pay_method: payForm.payMethod,
      upi_number: payForm.upiNumber,
      remain_interest_amount: selectedItem?.remain_interest_amount,
      remain_loan_amount: selectedItem?.remain_loan_amount
    };

    try {
      const response = await superAdminApis.financeUpdateAPI(payload);

      if (response?.apiStatus?.code === "200") {
        toast.success(response?.apiStatus?.message)
        const modal = document.getElementById("addfinancepay");
        const modalInstance = window.bootstrap.Modal.getInstance(modal);
        modalInstance.hide();
        setPayModal(false);
        handleFinanceList();
      }
    } catch (err) {
      toast.error(err?.apiStatus?.message)
      console.error(err);
    } finally {
      setSubmit(false);
    }
  };



  const handleView = async (item) => {
    console.log(item);

    const res = await superAdminApis.financeGet(item.id);
    setSelectedCustomer(res.result);
  };
  const [activeTab, setActiveTab] = useState("list");
  const [totalFinanceLoans, setTotalFinanceLoans] = useState(0);
  const [totalLoan, settotalLoan] = useState(0);
  const [totalInterest, settotalInterest] = useState(0);
  const [remainingFinanceAmt, setremainingFinanceAmt] = useState(0);
  const [remainingLoanAmt, setremainingLoanAmt] = useState(0);
  const [isLoanEditing, setIsLoanEditing] = useState(false);


  // const totalLoan = financeList.reduce(
  //   (sum, item) => sum + Number(item.loan_amount || 0),
  //   0
  // );

  // const totalInterest = financeList.reduce(
  //   (sum, item) => sum + Number(item.interest_amount || 0),
  //   0
  // );

  // const remaining = financeList.reduce(
  //   (sum, item) => sum + Number(item.remain_loan_amount || 0),
  //   0
  // );

  const activeCount = financeList.filter(
    (item) => item.paid_status === "true"
  ).length;

  const closedCount = financeList.filter(
    (item) => item.paid_status === "false"
  ).length;
  const financeLineData = {

    labels: [
      "Finance Amount",
      "Total Loan",
      "Total Interest",
      "Remaining Finance",
      "Remaining Loan"
    ],

    datasets: [

      {
        label: "Finance Amount",

        data: [
          totalFinanceLoans,
          totalLoan,
          totalInterest,
          remainingFinanceAmt,
          remainingLoanAmt
        ],

        borderColor: "#2563eb",

        backgroundColor:
          "rgba(37,99,235,0.15)",

        pointBackgroundColor: [
          "#0284c7",
          "#D4AF37",
          "#10b981",
          "#f97316",
          "#f916c4",
        ],

        pointBorderColor: "#fff",

        pointRadius: 7,

        pointHoverRadius: 10,

        borderWidth: 4,

        tension: 0.4,

        fill: true

      }

    ]

  };



  const financeLineOptions = {

    responsive: true,

    maintainAspectRatio: false,

    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          generateLabels: (chart) => {
            const datasets = chart.data.datasets;

            return datasets.map((dataset, i) => ({
              text: `${dataset.label}: ₹${totalFinanceLoans.toLocaleString()}`,
              fillStyle: dataset.backgroundColor,
              strokeStyle: dataset.borderColor,
              lineWidth: 2,
              hidden: !chart.isDatasetVisible(i),
              datasetIndex: i, // important
            }));
          },
        },
      },
    }
    ,


    scales: {


      y: {

        beginAtZero: true,

        ticks: {

          callback: function (value) {

            return "₹" + value.toLocaleString();

          }

        }

      }


    }

  };


  // const getPayMethod = (method) => {
  //   console.log(method);

  //   switch (method) {
  //     case "gpay":
  //       return <img src={gpay} width="54" />;
  //     case "phonepe":
  //       return <img src={phonepe} alt="phonepe" width="35" />;
  //     case "cash":
  //       return <span>💵 Cash</span>;
  //     case "account":
  //       return <span>🏦 Account</span>;
  //     default:
  //       return "-";
  //   }
  // };
  const getPayMethod = (method) => {

    switch (method) {

      case "gpay":
        return (
          <div className="payment-method-card gpay-card">
            <img src={gpay} alt="Google Pay" />
            <span>Google Pay</span>
          </div>
        );


      case "phonepe":
        return (
          <div className="payment-method-card phonepe-card">
            <img src={phonepe} alt="PhonePe" />
            <span>PhonePe</span>
          </div>
        );


      case "cash":
        return (
          <div className="payment-method-card cash-card">
            <div className="payment-icon">
              💵
            </div>

            <span>
              Cash
            </span>
          </div>
        );


      case "account":
        return (
          <div className="payment-method-card account-card">

            <div className="payment-icon">
              🏦
            </div>

            <span>
              Account
            </span>

          </div>
        );


      default:
        return (
          <span className="text-muted">
            No Method
          </span>
        );

    }

  };


  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mt-3 mb-1">

        {/* Left side (Breadcrumb) */}
        <nav aria-label="breadcrumb" className={lang === "ta" ? "fs-tamil" : ""}>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <a href="#" onClick={handleBackCustomer}>  {t("dashboard")}</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Finance Details
            </li>
          </ol>
        </nav>

        <div className="d-flex gap-3">

{/* {activeTab=="list" ?<button className="btn add-customer" onClick={handleBackCustomer}>
            <i className="fa fa-arrow-left me-2"></i> Back
          </button>:""} */}
          


      {activeTab=="list" &&(
          <button className="btn add-customer" data-bs-toggle="modal"
            data-bs-target="#addfinance">
            <i className="fa fa-plus me-2"></i> Add Finance
          </button>
          )}
        </div>

      </div>
      <div className="finance-tab-wrapper mt-4">

        <div className="finance-tabs">

          <button
            className={`finance-tab ${activeTab === "list" ? "active" : ""}`}
            onClick={() => setActiveTab("list")}
          >
            <span className="bg-circle"></span>

            <span className="tab-icon">
              <i className="fa-solid fa-table-list"></i>
            </span>

            <div className="tab-text">
              <h6>Customer List</h6>
              <small>Manage Finance</small>
            </div>

            <span className="active-light"></span>
          </button>


          <button
            className={`finance-tab ${activeTab === "dashboard" ? "active" : ""}`}
            onClick={() => { setActiveTab("dashboard"); handleGetFinanceAmt("1") }}
          >
            <span className="bg-circle"></span>
            <span className="tab-icon dashboard">
              <i className="fa-solid fa-chart-line"></i>
            </span>

            <div className="tab-text">
              <h6>Dashboard</h6>
              <small>Overview Report</small>
            </div>

            <span className="active-light"></span>
          </button>

        </div>

      </div>

      <div className="tab-body mt-4">

        {activeTab === "list" && (
          <div className="tab-animation">
            <div className='customer-list-container card'>
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-2 mb-3">
                <h5 className={`heading-with-line  mb-md-0 aquanew-text-effect ${lang === "ta" ? "fs-tamil" : ""}`}>
                  <i className="bi bi-journal-text me-1"></i>
                  Customer Finance List
                  <span className="smooth-line"></span>
                </h5>
              </div>
              <div className='table-section' data-aos="fade-up">
                <table className=" table-bordered">
                  <thead className="table-light">
                    <tr>
                      <th>Sl No</th>
                      <th>Name</th>
                      <th>Date</th>
                      <th>Loan Amt</th>
                      <th>Interest Rate</th>
                      <th>Interest Amt</th>

                      <th>Remaining</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="10" className="text-center">
                          <div className="gold-dots-loader">
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                        </td>
                      </tr>
                    ) : financeList && financeList.length > 0 ? (
                      financeList?.map((item, index) => (
                        <tr key={item?.id || index} className="customer-table-td">
                          <td>
                            {(currentPage - 1) * recordsPerPage + index + 1}
                          </td>

                          <td>{item?.name}</td>
                          <td>{item?.date}</td>
                          <td>₹{item?.loan_amount}</td>
                          <td>{item?.interest_rate + "%"}</td>

                          <td>₹{item?.total_interest}</td>
                          <td className="text-danger fw-bold">₹{item.remain_loan_amount || "0"}</td>
                          <td>
                            <span className={`badge ${item.paid_status === "true" ? "bg-success" : "bg-danger"}`}>
                              {item.paid_status == "false" ? "Closed" : "Active"}
                            </span>
                          </td>

                          <td className="text-center d-flex justify-content-center align-items-center">

                            <span className="icon-btn edit tooltip-box" data-bs-toggle="modal"
                              data-bs-target="#addfinance" onClick={() => handleEdit(item)}>
                              <i className="fa-solid fa-pen-to-square"></i>
                              <span className="tooltip-text">Edit</span>
                            </span>

                            <span className="icon-btn view tooltip-box" data-bs-toggle="modal" data-bs-target="#addfinanceview" onClick={() => handleView(item)}>
                              <i class="fa-solid fa-eye"></i>
                              <span className="tooltip-text">View</span>
                            </span>

                            <span className="icon-btn pay tooltip-box" data-bs-toggle="modal" data-bs-target="#addfinancepay" onClick={() => handlePayClick(item)}>
                              <i className="fa-brands fa-amazon-pay"></i>
                              <span className="tooltip-text">Pay</span>
                            </span>

                            <span className="icon-btn delete tooltip-box" onClick={() => {
                              setFinanceDeleteId(item?.id);
                              setCustomerName(item?.name);
                            }} data-bs-toggle="modal"
                              data-bs-target="#financeDelete">
                              <i className="fa-solid fa-trash"></i>
                              <span className="tooltip-text">Delete</span>
                            </span>

                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="10" className={`text-center ${lang === "ta" ? "fs-tamil" : ""}`}>
                          {t("noRecords")}
                        </td>
                      </tr>
                    )}
                  </tbody>



                  {/* <tbody>
    {financeList.map((item) => (
      <tr key={item.id}>
        <td>1</td>
        <td>{item.name}</td>
        <td>{item.date}</td>
        <td>₹{item.amount}</td>
        <td>{item.interestRate}</td>

        <td>₹{item.interest}</td>
        <td className="text-danger fw-bold">₹{item.remaining}</td>
        <td>
          <span className={`badge ${item.status === "Active" ? "bg-success" : "bg-warning"}`}>
            {item.status}
          </span>
        </td>

         <td className="text-center" style={{ width: "10rem" }}>
                  <div className="action-buttons-wrapper">
                    <div className="action-buttons">
                      <Link
                        to={``}
                        className="btn-view view-btn"
                         data-tooltip="View"
                         style={{color:'blue',background:'azure'}}
                           data-bs-toggle="modal" data-bs-target="#addfinanceview"
                        onClick={() => setSelectedCustomer(item)}
                      >
                      <i class="fa-solid fa-eye"></i>
                      </Link>
        
                      <Link
                        to={""}
                        onClick={() => handleEdit(item)}
                        className="btn-view edit-btn"
                        data-tooltip="Edit"

                      >
                        <i className="fa-solid fa-pen-to-square"></i>
                      </Link>
        
                      <Link
                        to={``}
                         data-bs-toggle="modal" data-bs-target="#addfinancepay" onClick={() => handlePayClick(item)}
                        className="btn-view pay-btn"
                         data-tooltip="Pay"
                      >
                       <i className="fa-brands fa-amazon-pay"></i>
                      </Link>
                    </div>
        
                    <button
                      className="btn-view delete-btn"
                    onClick={() => handleDelete(item.id)}  data-bs-toggle="modal"
              data-bs-target="#financeDelete"
                      // onClick={() => {
                      //   setCustomerDeleteId(customer?.id);
                      //   setCustomerName(customer?.name);
                      // }}
                       data-tooltip="Delete"
                    >
                     <i className="fa-solid fa-trash"></i>
                    </button>
                  </div>
                </td> 



      </tr>
    ))}
  </tbody> */}


                </table>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-3 flex-wrap">

                {/* LEFT SIDE */}
                <div className="d-flex align-items-center gap-2">
                  <select
                    className="form-select form-select-sm"
                    style={{ width: "80px" }}
                    value={recordsPerPage}
                    onChange={(e) => setRecordsPerPage(Number(e.target.value))}
                  >
                    {pageSizes?.map((size) => (
                      <option key={size} value={size}>
                        {size}
                      </option>
                    ))}
                  </select>

                  <span className={lang === "ta" ? "fs-tamil" : ""}>
                    {t("showing")} {(currentPage - 1) * recordsPerPage + 1} -{" "}
                    {Math.min(currentPage * recordsPerPage, totalRecords)} {t("of")}{" "}
                    {totalRecords}
                  </span>
                </div>

                {/* RIGHT SIDE */}
                <div>
                  <CommonPagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={setCurrentPage}
                  />
                </div>

              </div>

            </div>
          </div>
        )}

        {activeTab === "dashboard" && (
          <div className="tab-animation">
            <div className='customer-list-container card'>
              <div className="row g-4 mt-1">

                <div className="col-lg-4 col-md-6">
                  <div
                    className="dashboard-card loan"
                    onClick={() => setIsLoanEditing(true)}
                    style={{ cursor: "pointer" }}
                  >
                    <i className="fa-solid fa-wallet"></i>

                    <h6>Finance Amount</h6>

                    {isLoanEditing ? (
                      <input
                        className="loan-input"
                        type="number"
                        value={totalFinanceLoans}
                        autoFocus
                        onChange={(e) => setTotalFinanceLoans(e.target.value)}
                        onBlur={() => { setIsLoanEditing(false); handleGetFinanceUpdate() }}
                      />
                    ) : (
                      <h3>₹{totalFinanceLoans.toLocaleString()}</h3>
                    )}

                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="dashboard-card total-interest">

                    <i className="fa-solid fa-percent"></i>

                    <h6>Total Interest</h6>

                    <h3>₹{totalInterest.toLocaleString()}</h3>

                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="dashboard-card remain">

                    <i className="fa-solid fa-money-bill-wave"></i>

                    <h6>Remaining</h6>

                    <h3>₹{remainingLoanAmt.toLocaleString()}</h3>

                  </div>
                </div>



              </div>
              <div className="d-flex mt-4">


                <div className="col-lg-12">


                  <div className="finance-line-card">


                    <div className="chart-header">

                      <h5>
                        Finance Growth Overview
                      </h5>

                      <p>
                        Loan, Interest & Remaining Amount
                      </p>

                    </div>



                    <div className="line-chart-box">


                      <Line

                        data={financeLineData}

                        options={financeLineOptions}

                      />


                    </div>



                  </div>


                </div>


              </div>
            </div>


          </div>

        )
        }
      </div>


      {/* Add finance modal */}

      <div className="modal fade" id="addfinance" tabIndex="-1">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content shadow-lg rounded-3">

            {/* HEADER */}
            <div className="modal-header text-white" style={{ background: "#7FB77E" }}>
              <h6 className="modal-title">Add Finance</h6>
              <button className="btn-close btn-close-white" data-bs-dismiss="modal" onClick={closeClick}></button>
            </div>

            {/* BODY */}
            <div className="modal-body">
              <div className="row border-input-hover">

                {/* NAME */}
                <div className="col-md-4">
                  <label>Name</label>
                  <input className="form-control" name="name"
                    value={form.name} onChange={handleChange} />
                </div>

                <div className="col-md-4">
                  <label className='required-star'>Phone Number</label>
                  <input
                    type="tel"
                    className="form-control"
                    name="phoneNumber"
                    value={form.phoneNumber}
                    onChange={handleChange}
                    placeholder="10 digit mobile number"
                style={submit && form.phoneNumber.length === 0 ? { borderColor: 'red' } : {}}

                  />
                {submit && form.phoneNumber.length === 0 ? <div className='text-danger'>Phone number is required</div> : ""}

                </div>

                {/* DATE */}
                <div className="col-md-4">
                  <label className='required-star'>Date</label>
                  <input type="date"
                    onClick={(e) => {
                      const input = e.currentTarget;
                      if (typeof input.showPicker === "function") {
                        input.showPicker();
                      } else {
                        input.focus();
                      }
                    }}

                    className="form-control"
                    name="date"
                    value={form.date}
                    onChange={handleChange} 
                    
                                    style={submit && form.date.length === 0 ? { borderColor: 'red' } : {}}

                    />
                                    {submit && form.date.length === 0 ? <div className='text-danger'>Date is required</div> : ""}

                </div>

                {/* Adhar */}
                <div className="col-md-6 mt-4">
                  <label className="upload-label">Aadhar Photo</label>

                  <div className="upload-container-custom" onClick={() => aadharInputRef.current?.click()}>
                    <input
                      ref={aadharInputRef}
                      type="file"
                      id="aadharUpload"
                      multiple
                      className="upload-input-hidden"
                      onChange={handleAadharChange}
                    />

                    <label htmlFor="aadharUpload" className="upload-btn-custom">
                      + Upload
                    </label>

                    <div className="preview-list">
                      {form?.adharPreview?.length > 0 ? (
                        form.adharPreview.map((preview, index) => {
                          const imageUrl =
                            typeof preview === "string"
                              ? preview
                              : preview.path && preview.altered_file_name
                                ? `${baseURL}${preview.path}${preview.altered_file_name}`
                                : Noimage;

                          const fileName =
                            form?.adharFile?.[index]?.name ||
                            preview?.altered_file_name ||
                            `Image ${index + 1}`;

                          return (
                            <div className="preview-item" key={index}>
                              <img
                                src={imageUrl}
                                alt={fileName}
                                className="preview-thumb"
                                onError={(e) => (e.target.src = Noimage)}
                              />
                              <span className="preview-name" style={{ maxWidth: form?.adharPreview?.length == 1 &&( "200px") }}>{fileName}</span>
                            </div>
                          );
                        })
                      ) : (
                        <span htmlFor="aadharUpload" className="no-file-text">No files selected</span>
                      )}
                    </div>
                  </div>
                </div>

                {/* Live Pic */}
                <div className="col-md-6 mt-4"> <div className="form-group">
                  <label className="form-control-label">  {t("livePic")}</label>
                  <div className="d-flex align-items-center gap-3">
                    <img src={imageSrc || form.livePreview || Noimage} alt="Profile" style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: "cover", border: '2px solid #ccc', }} />
                    <div className="d-flex gap-2 upload-capture-btn">
                      <button type="button" className="btn btn-secondary" onClick={handleUploadClick} >
                        {t("upload")}
                      </button>
                      <input type="file" accept="image/*" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} />
                      <button
                        type="button"
                        className="btn btn-outline-primary"
                        onClick={() => setShowCamera(true)}
                      >
                        {t("capture")}
                      </button>
                    </div>
                  </div>
                </div>
                </div>





                {/* AMOUNT */}
                <div className="col-md-6 mt-2">
                  <label>Loan Amount</label>
                  <input type="number" className="form-control"
                    name="amount"
                    value={form.amount}
                    onChange={handleChange} />
                </div>

                {/* RATE */}
                <div className="col-md-6 mt-2">
                  <label>Interest Rate (%)</label>
                  <select className="form-control"
                    name="interestRate"
                    value={form.interestRate}
                    onChange={handleChange}>
                    <option disabled value="">Select</option>
                    <option value="12">12%</option>
                    <option value="13">13%</option>
                    <option value="14">14%</option>
                    <option value="15">15%</option>
                    <option value="20">20%</option>

                  </select>
                </div>

                {/* DURATION */}
                <div className="col-md-6 mt-2">
                  <label>Pay Duration</label>
                  <select className="form-control"
                    name="payDuration"
                    value={form.payDuration}
                    onChange={handleChange}>
                    <option disabled value="">Select</option>
                    <option value="Daily">Daily</option>
                    <option value="Weekly">Weekly</option>
                    <option value="Monthly">Monthly</option>
                  </select>
                </div>

                {/* INTEREST */}
                <div className="col-md-6 mt-2">
                  <label>Total Interest</label>
                  <input className="form-control bg-light"
                    value={form.intrestamount}
                    readOnly />
                </div>

                {/* WEEKLY / EMI */}
                <div className="col-md-6 mt-2">
                  <label>One Weekly Interest</label>
                  <input className="form-control bg-light"
                    value={form.weeklyInterest}
                    readOnly />
                </div>

                {/* TOTAL PAYABLE */}
                <div className="col-md-6 mt-2">
                  <label>Total Payable</label>
                  <input className="form-control bg-light fw-bold text-success"
                    value={form.totalPayable}
                    readOnly />
                </div>

                {/* PAY METHOD */}
                {/* <div className="col-md-6 mt-2">
            <label>Pay Method</label>
            <select className="form-control"
              name="payMethod"
              value={form.payMethod}
              onChange={handleChange}>
              <option value="">Select</option>
              <option value="gpay">GPay</option>
              <option value="phonepe">PhonePe</option>
              <option value="cash">Cash</option>
              <option value="account">Account</option>
            </select>
          </div> */}

                {/* CONDITIONAL FIELDS */}
                {form.payMethod === "gpay" && (
                  <div className="col-md-6 mt-2">
                    <label>GPay Number</label>
                    <input className="form-control"
                      name="gpayNumber"
                      value={form.gpayNumber}
                      onChange={handleChange} />
                  </div>
                )}

                {form.payMethod === "phonepe" && (
                  <div className="col-md-6 mt-2">
                    <label>PhonePe Number</label>
                    <input className="form-control"
                      name="phonePeNumber"
                      value={form.phonePeNumber}
                      onChange={handleChange} />
                  </div>
                )}

              </div>
            </div>

            {/* FOOTER */}

            {selectedItem?.paid_status == "false" ? <div style={{ textAlign: 'center', padding: '20px', background: "lightgreen", fontWeight: "600" }}>This Finance is fully closed !</div> : <div className="modal-footer justify-content-center">
              <button className="btn btn-secondary" data-bs-dismiss="modal" onClick={closeClick}>
                Cancel
              </button>

              <button className="btn add-customer" onClick={financeCreate}>
                Submit
              </button>
            </div>}



          </div>
        </div>
      </div>


      {/* Pay modal */}

      <div className="modal fade" id="addfinancepay" tabIndex="-1">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content shadow-lg rounded-3">

            {/* HEADER */}
            <div className="modal-header text-white" style={{ background: "#7FB77E" }}>
              <h6 className="modal-title">Finance Loan Payment</h6>
              <button
                className="btn-close btn-close-white"
                data-bs-dismiss="modal" onClick={closeClickPay}
              // onClick={() => setPayModal(false)}
              ></button>
            </div>

            {/* BODY */}
            <div className="modal-body border-input-hover">
              <div className="mb-4 p-3 rounded" style={{ background: "#f1f8f5", border: "1px solid #d4edda" }}>

                <div className="row text-center">

                  <div className="col-6">
                    <p className="mb-1 text-muted">Pay Duration</p>
                    <h6 className="fw-bold text-danger">
                      {selectedItem?.pay_duration || "-"}
                    </h6>
                  </div>

                  <div className="col-6">
                    <p className="mb-1 text-muted">Pay Amount</p>
                    <h6 className="fw-bold text-success">
                      {selectedItem?.pay_duration === "Daily"
                        ? `₹${selectedItem?.weekly_interest || 0}`
                        : selectedItem?.pay_duration === "Weekly"
                          ? `₹${selectedItem?.weekly_interest || 0}`
                          : selectedItem?.pay_duration === "Monthly"
                            ? `₹${selectedItem?.weekly_interest || 0}`
                            : "-"}
                    </h6>

                  </div>
                  <hr className="my-3" style={{ borderColor: "#d4edda" }} />

                  {/* REMAINING */}
                  <div className="col-6">
                    <p className="mb-1 text-muted">Remaining Principal</p>
                    <h6 className="fw-bold text-danger">
                      {selectedItem?.remain_interest_amount == null
                        ? `₹${selectedItem?.loan_amount || 0}`
                        : Number(selectedItem?.remain_loan_amount) > 0
                          ? selectedItem?.remain_loan_amount
                          : selectedItem?.remain_loan_amount || "0"
                      }
                    </h6>

                  </div>

                  {/* PRINCIPAL SUGGEST */}
                  {/* <div className="col-4">
      <p className="mb-1 text-muted">Principal Due</p>
      <h6 className="fw-bold text-primary">₹{selectedItem?.remain_interest_amount||"0"} </h6>
    </div> */}

                  {/* INTEREST SUGGEST */}
                  <div className="col-6">
                    <p className="mb-1 text-muted">Remaining Interest Due</p>

                    <h6 className="fw-bold text-warning">
                      {selectedItem?.remain_interest_amount == null
                        ? `₹${selectedItem?.total_interest || 0}`
                        : Number(selectedItem?.remain_interest_amount) === 0
                          ? <div className='text-success'>Interest Successfully Paid</div>
                          : `₹${selectedItem?.remain_interest_amount}`}
                    </h6>
                  </div>

                </div>
              </div>
              <div className="row">

                {/* NAME */}
                <div className="col-md-6 mb-2">
                  <label>Name</label>
                  <input
                    className="form-control"
                    value={payForm?.name || ""}
                    disabled
                  />
                </div>

                {/* PRINCIPAL */}
                <div className="col-md-6 mb-2">
                  <label>Principal Pay</label>
                  <input
                    type="number"
                    className="form-control"
                    disabled={selectedItem?.paid_status === "false"}
                    style={{
                      cursor: selectedItem?.paid_status === "false" ? "not-allowed" : "default"
                    }}
                    value={payForm.principalPay}
                    onChange={(e) =>
                      setPayForm({ ...payForm, principalPay: e.target.value })
                    }
                  />
                </div>

                {/* INTEREST */}
                {selectedItem?.interest_status === "false" ? (
                  <div className="col-md-6 mb-2" >
                    <label>Interest Pay</label>
                    <div className="text-success fw-bold form-control" style={{ borderColor: 'green' }}>
                      முழு வட்டி  செலுத்தப்பட்டது
                    </div>
                  </div>
                ) : (
                  <div className="col-md-6 mb-2">
                    <label>Interest Pay</label>
                    <input
                      type="number"
                      className="form-control"
                      value={payForm.interestPay}
                      onChange={(e) =>
                        setPayForm({ ...payForm, interestPay: e.target.value })
                      }
                      
                    />

                    {submit &&
  Number(payForm.principalPay || 0) >=
    (selectedItem?.remain_interest_amount == null
      ? Number(selectedItem?.loan_amount || 0)
      : Number(selectedItem?.remain_loan_amount || 0)) &&
  selectedItem?.interest_status !== "false" &&
  !payForm.interestPay && (
    <div className="text-danger">
      Interest payment is required
    </div>
)}
                  </div>
                )}

                {/* PAY DATE */}
                <div className="col-md-6 mb-2">
                  <label className='required-star'>Pay Date</label>
                  <input
                    type="date"
                    onClick={(e) => {
                      const input = e.currentTarget;
                      if (typeof input.showPicker === "function") {
                        input.showPicker();
                      } else {
                        input.focus();
                      }
                    }}
                    className="form-control"
                    value={payForm.payDate}
                    disabled={selectedItem?.paid_status === "false"}
                    style={{
                      cursor: selectedItem?.paid_status === "false" ? "not-allowed" : "pointer"
                    }}
                    onChange={(e) =>
                      setPayForm({ ...payForm, payDate: e.target.value })
                    }
                    style={submit && payForm.payDate.length === 0 ? { borderColor: 'red' } : {}}
                  />
                  {submit && payForm.payDate.length === 0 ? <div className='text-danger'>Pay date is required</div> : ""}
                </div>

                {/* PAY METHOD */}
                <div className="col-md-6 mb-2">
                  <label>Pay Method</label>
                  <select
                    className="form-control"
                    value={payForm.payMethod}
                    disabled={selectedItem?.paid_status === "false"}
                    style={{
                      cursor: selectedItem?.paid_status === "false" ? "not-allowed" : "pointer"
                    }}
                    onChange={(e) =>
                      setPayForm({ ...payForm, payMethod: e.target.value })
                    }
                  >
                    <option value="">Select Method</option>
                    <option value="gpay">GPay</option>
                    <option value="phonepe">PhonePe</option>
                    <option value="cash">Cash</option>
                    <option value="account">Account</option>
                  </select>
                </div>

                {/* CONDITIONAL FIELDS */}
                {payForm.payMethod === "gpay" && (
                  <div className="col-md-6 mb-2">
                    <label>GPay Number</label>
                    <input
                      className="form-control"
                      value={payForm.gpayNumber}
                      maxLength={10}
                      onChange={(e) =>
                        setPayForm({ ...payForm, gpayNumber: e.target.value })
                      }
                    />
                  </div>
                )}

                {payForm.payMethod === "phonepe" && (
                  <div className="col-md-6 mb-2">
                    <label>PhonePe Number</label>
                    <input
                      className="form-control"
                      maxLength={10}
                      value={payForm.phonePeNumber}
                      onChange={(e) =>
                        setPayForm({ ...payForm, phonePeNumber: e.target.value })
                      }
                    />
                  </div>
                )}

                {payForm.payMethod === "account" && (
                  <div className="col-md-6 mb-2">
                    <label>Account Number</label>
                    <input
                      className="form-control"
                      value={payForm.accountNumber}
                      onChange={(e) =>
                        setPayForm({ ...payForm, accountNumber: e.target.value })
                      }
                    />
                  </div>
                )}

              </div>
            </div>

            {/* FOOTER */}

            {selectedItem?.paid_status == "false" ? <div style={{ textAlign: 'center', padding: '20px', background: "lightgreen", fontWeight: "600" }}>This Finance is fully closed !</div> : <div className="modal-footer justify-content-center">
              <button
                className="btn btn-secondary"
                data-bs-dismiss="modal" onClick={closeClickPay}
              >
                Cancel
              </button>

              <button className="btn add-customer" onClick={handlePay}>
                Submit Payment
              </button>
            </div>}




          </div>
        </div>


      </div>

      {/* view moadl */}

      <div
        className="modal fade"
        id="addfinanceview"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden finance-modal">

            {/* HEADER */}
            <div
              className="modal-header text-white"
              style={{
                background:
                  "linear-gradient(135deg,#7FB77E,#4f9f62)", padding: "10px 25px"
              }}
            >
              <div>
                <h5 className="modal-title fw-bold mb-1">
                  <i className="bi bi-wallet2 me-2"></i>
                  Customer Finance View
                </h5>
                <small className="opacity-75">
                  Loan & Payment Details
                </small>
              </div>

              <button
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                onClick={closeClick}
              ></button>
            </div>


            {/* BODY */}
            <div className="modal-body bg-light p-4">

              {selectedCustomer && (
                <>


                  {/* CUSTOMER PROFILE CARD */}
                  {/* TOP SECTION */}
                  <div className="card border-0 shadow-sm rounded-4 mb-4 animate-card">

                    <div className="card-body">

                      {/* CUSTOMER FINANCE PROFILE */}

                      <div className="finance-profile-card">


                        <div className="row g-0 align-items-stretch">


                          {/* CUSTOMER PHOTO */}

                          <div className="col-lg-2 profile-side">

                            <div className="photo-wrapper">

                              <img
                                src={
                                  selectedCustomer?.liveImage?.path && selectedCustomer?.liveImage?.altered_file_name
                                    ? `${baseURL}${selectedCustomer.liveImage.path}${selectedCustomer.liveImage.altered_file_name}`
                                    : Noimage
                                }
                                alt="customer"
                                className="customer-photo"
                              />

                              <div className="online-dot"></div>

                            </div>


                            <h6 className="mt-3">
                              {selectedCustomer.name}
                            </h6>

                            <span>
                              Customer Profile
                            </span>

                          </div>







                          {/* CUSTOMER DETAILS */}

                          <div className="col-lg-5 details-side">


                            <div className="details-grid">



                              <div className="detail-card">

                                <div className="detail-icon purple">
                                  <i className="bi bi-person-fill"></i>
                                </div>

                                <div>
                                  <small>Name</small>
                                  <h6>{selectedCustomer.name}</h6>
                                </div>

                              </div>





                              <div className="detail-card">

                                <div className="detail-icon green">
                                  <i className="bi bi-telephone-fill"></i>
                                </div>

                                <div>
                                  <small>Phone</small>
                                  <h6>{selectedCustomer.phone_no}</h6>
                                </div>

                              </div>





                              <div className="detail-card">

                                <div className="detail-icon orange">
                                  <i className="bi bi-calendar-event"></i>
                                </div>

                                <div>
                                  <small>Date</small>
                                  <h6>{selectedCustomer.date}</h6>
                                </div>

                              </div>






                              <div className="detail-card amount-card">

                                <div className="detail-icon money">
                                  <i className="bi bi-currency-rupee"></i>
                                </div>

                                <div>
                                  <small>Loan Amount</small>
                                  <h6>
                                    ₹{selectedCustomer.loan_amount}
                                  </h6>
                                </div>

                              </div>






                              <div className="detail-card">

                                <div className="detail-icon red">
                                  <i className="bi bi-percent"></i>
                                </div>

                                <div>
                                  <small>Interest</small>
                                  <h6>
                                    {selectedCustomer.interest_rate}%
                                  </h6>
                                </div>

                              </div>







                              <div className="detail-card">

                                <div className="detail-icon blue">
                                  <i className="bi bi-shield-check"></i>
                                </div>


                                <div>

                                  <small>Status</small>


                                  <h6>

                                    <span
                                      className={
                                        selectedCustomer.paid_status === "true"
                                          ?
                                          "status-active"
                                          :
                                          "status-close"
                                      }
                                    >

                                      {
                                        selectedCustomer.paid_status === "true"
                                          ?
                                          "Active"
                                          :
                                          "Closed"
                                      }

                                    </span>

                                  </h6>


                                </div>


                              </div>



                            </div>


                          </div>







                          {/* AADHAAR */}

                          <div className="col-lg-5 details-side">


                            <div className="aadhaar-title">

                              <i className="bi bi-card-image"></i>

                              Aadhaar Verification

                            </div>



                            <div className="row justify-content-center">
                              {selectedCustomer?.aadharImage?.length > 0 ? (
                                selectedCustomer.aadharImage.map((img, index) => (
                                  <div className="col-md-6" key={index}>
                                    <div className="aadhaar-card">
                                      <div className="aadhaar-label">
                                        {index === 0 ? "FRONT" : "BACK"}
                                      </div>

                                      <img
                                        src={`${baseURL}${img.path}${img.altered_file_name}`}
                                        alt="aadhaar"
                                      />
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className="col-md-6 d-flex justify-content-center">
                                  <div className="aadhaar-card">
                                    <div className="aadhaar-label">AADHAAR</div>

                                    <img
                                      src={Noimage}
                                      alt="No Aadhaar"
                                    />
                                  </div>
                                </div>
                              )}
                            </div>


                          </div>




                        </div>


                      </div>


                    </div>

                  </div>






                  {/* PAYMENT TABLE */}

                  {/* PAYMENT HISTORY SECTION */}

                  <div className="card border-0 shadow-lg rounded-3 overflow-hidden payment-card">


                    {/* HEADER */}

                    <div className="payment-header">

                      <div>
                        <h5 className="mb-1 fw-bold text-white">
                          <i className="bi bi-cash-stack me-2"></i>
                          Payment History
                        </h5>

                        <small className="text-white opacity-75">
                          Loan repayment transactions
                        </small>

                      </div>


                      <div className="payment-count">

                        <i className="bi bi-receipt me-1"></i>

                        {
                          selectedCustomer?.payment_history?.length || 0
                        }

                        Payments

                      </div>


                    </div>





                    {/* TABLE */}

                    <div className="table-responsive p-3">


                      <table className="table payment-table align-middle mb-0">


                        <thead>

                          <tr>

                            <th>#</th>
                            <th>Customer</th>
                            <th>Principal</th>
                            <th>Interest</th>
                            <th>Payment Mode</th>
                            <th>Time</th>
                            <th>Date</th>

                          </tr>

                        </thead>



                        <tbody>


                          {
                            selectedCustomer?.payment_history?.length > 0 ?


                              selectedCustomer.payment_history.map((item, index) => (


                                <tr key={index}>


                                  <td>

                                    <div className="number-circle">

                                      {index + 1}

                                    </div>

                                  </td>




                                  <td>

                                    <div className="customer-name">

                                      <i className="bi bi-person-circle"></i>

                                      {selectedCustomer.name}

                                    </div>

                                  </td>




                                  <td>

                                    <span className="amount principal">

                                      ₹{item.principal_pay}

                                    </span>

                                  </td>




                                  <td>

                                    <span className="amount interest">

                                      ₹{item.interest_pay}

                                    </span>

                                  </td>




                                  <td>

                                    {/* <span className="pay-badge">

<i className="bi bi-wallet-fill me-1"></i> */}

                                    {getPayMethod(item.pay_method)}

                                    {/* </span> */}

                                  </td>




                                  <td>

                                    <div className="date-time">

                                      <i className="bi bi-clock"></i>


                                      {
                                        new Date(item.pay_date.replace(" ", "T"))
                                          .toLocaleTimeString(
                                            "en-IN",
                                            {
                                              hour: "2-digit",
                                              minute: "2-digit",
                                              hour12: true
                                            }
                                          )

                                      }

                                    </div>


                                  </td>




                                  <td>

                                    <div className="date-time">

                                      <i className="bi bi-calendar3"></i>

                                      {item.pay_date.split(" ")[0]}

                                    </div>


                                  </td>



                                </tr>


                              ))


                              :


                              <tr>

                                <td colSpan="7"
                                  className="text-center py-5 text-muted">


                                  <i className="bi bi-folder-x fs-2 d-block mb-2"></i>

                                  No Payment History Available


                                </td>

                              </tr>


                          }


                        </tbody>


                      </table>


                    </div>


                  </div>




                </>

              )}


            </div>




            {/* FOOTER */}

            <div className="modal-footer bg-white">

              <button
                className="btn btn-outline-secondary px-4 rounded-pill"
                data-bs-dismiss="modal"
              >
                Close
              </button>

            </div>


          </div>
        </div>
      </div>








      <div
        className="modal fade"
        id="financeDelete"
        tabIndex="-1"
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">

            <div className="modal-header text-white" style={{ background: "#7FB77E" }}>
              <h6 className={`modal-title ${lang === "ta" ? "fs-tamil" : ""}`} id="deleteModalLabel">
                {t("confirmDelete")}
              </h6>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closedeleteModal"
              ></button>
            </div>

            <div className={`modal-body text-center ${lang === "ta" ? "fs-tamil" : ""}`}>
              Are you sure you want to delete this customer {customerName} ?
              {/* <span className="delete-customer-name">{customerName}</span> ? */}
            </div>

            <div className="modal-footer justify-content-center">

              <button
                type="button"
                className={`btn add-customer ${lang === "ta" ? "fs-tamil" : ""}`}
                onClick={handleDeleteFinance}
              >
                {t("yesDelete")}
              </button>

              <button
                type="button"
                className={`btn btn-secondary ${lang === "ta" ? "fs-tamil" : ""}`}
                data-bs-dismiss="modal"
              >
                {t("cancel")}
              </button>

            </div>

          </div>
        </div>
      </div>


      {/* Camera Modal */}
      {showCamera && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
          style={{
            background: "rgba(0,0,0,0.5)",
            zIndex: 9999,
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            style={{ maxWidth: "480px", width: "100%" }}
          >
            <div className="modal-content bg-white p-3 rounded">

              <div className="modal-header mb-3">
                <h5 className="modal-title">Capture Photo</h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowCamera(false)}
                ></button>
              </div>

              <div className="modal-body text-center">
                <video
                  ref={videoRef}
                  autoPlay
                  playsInline
                  style={{
                    width: "100%",
                    borderRadius: "8px",
                  }}
                />

                <canvas
                  ref={canvasRef}
                  style={{ display: "none" }}
                ></canvas>
              </div>

              <div className="modal-footer justify-content-center mt-2">

                {/* <button
            className="btn btn-secondary me-2"
            onClick={handleToggleCamera}
          >
            Switch Camera
          </button> */}

                <button
                  className="btn btn-primary"
                  onClick={async () => {
                    await handleCapture();
                    setShowCamera(false);
                  }}
                >
                  Capture
                </button>

              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default AddFinance
